export enum CustomerToggleBasedPermissionKeys {
  canSeeOrderAndDeliveries = 'canSeeOrderAndDeliveries',
  canCreateOrders = 'canCreateOrders',
  canChangeOrders = 'canChangeOrders',
  canSeeInvoices = 'canSeeInvoices'
}

export type CustomerToggleBasedPermissions = {
  [CustomerToggleBasedPermissionKeys.canSeeOrderAndDeliveries]?: boolean
  [CustomerToggleBasedPermissionKeys.canChangeOrders]?: boolean
  [CustomerToggleBasedPermissionKeys.canCreateOrders]?: boolean
  [CustomerToggleBasedPermissionKeys.canSeeInvoices]?: boolean
}

export type DataScopeOption = {
  label: string
  value: string
}
